import { Trash } from "lucide-react";
import { useState } from "react";
import { User } from "../../types/user";
import { useUserServices } from "../../hooks/useUserService";

interface AdminTabProps {
    user: User;
}

export default function AdministratorTab({ user }: AdminTabProps) {
    const [enabled, setEnabled] = useState(false);
    const services = useUserServices(user.email || user.phone || "");
    return (
        <div className="max-w-6xl bg-card rounded-xl p-4">
            <table className="w-full text-xs table-fixed">
                <thead className="border-b border-gray-400 text-gray-200">
                    <tr>
                        <th className="w-1/10 text-center font-light py-2">Service</th>
                        <th className="w-1/10 text-center font-light py-2">Status</th>
                        <th className="w-1/10 text-center font-light py-2">Actions</th>
                    </tr>
                </thead>

                <tbody className="text-white">
                    {services.map((service) => (
                        <tr className="bg-card/50">
                        <td className="w-1/10 text-center py-2">{service.serviceName}</td>
                        <td className="w-1/10 text-center py-2">Active</td>
                        <td className="w-1/10 text-center py-2 flex items-center justify-center">
                            <button
                                type="button"
                                className={`w-7 h-4 flex items-center rounded-full p-1 transition-colors duration-300 ${enabled ? "bg-green-500" : "bg-gray-300"
                                    }`}
                                onClick={() => setEnabled(!enabled)}
                            >
                                <div
                                    className={`w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ${enabled ? "translate-x-3" : ""
                                        }`}
                                />
                            </button>
                            <button className="bg-none text-kanema rounded-lg py-1 px-2 hover:scale-105 cursor-pointer hover:scale-110">
                                <Trash size={18} />
                            </button>
                            <button className="bg-none text-white text-xs py-1 hover:scale-105 cursor-pointer">Reset Password</button>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}